import React from "react";

const UpdateProduct = () => {
  return <div>Update Product</div>;
};

export default UpdateProduct;
